
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternative-entry-method",
      function () {
        return require("private-next-pages/alternative-entry-method.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternative-entry-method"])
      });
    }
  